// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const KeyboardIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="KeyboardIcon" ref={forwardedRef} {...props}>
      <path d="M2 10.252a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M6.875 10.252a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M11 10.252a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M15.5 10.252a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M2 5.752a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M6.5 5.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M11 5.75a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M15.5 5.752a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0" />
      <path d="M4 15.002a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 0 1.5H4.75A.75.75 0 0 1 4 15.002" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const KeyboardIcon = /* @__PURE__ */ Object.assign(
  KeyboardIconComponent,
  { displayName: 'KeyboardIcon' },
);
